var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-body", attrs: { id: "shipping-amazon" } },
    [
      _c("p", { staticClass: "text-size-20" }, [
        _vm._v(
          "ACROSS倉庫にある商品をAmazon倉庫へ出荷（納品）する依頼を作成することができます"
        )
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mr-t-20", staticStyle: { "min-width": "1500px" } },
        [
          _c("div", { staticClass: "flexbox gap-15" }, [
            _c("svg", { attrs: { width: "50", height: "50" } }, [
              _c("circle", {
                attrs: {
                  cx: "25",
                  cy: "25",
                  r: "20",
                  stroke: "#008cc6",
                  "stroke-width": "3",
                  fill: "#008cc6"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  attrs: {
                    x: "50%",
                    y: "50%",
                    "text-anchor": "middle",
                    "dominant-baseline": "central",
                    "font-size": "20",
                    fill: "#fff"
                  }
                },
                [_vm._v("1")]
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "font-bold text-size-16 text-primary" }, [
              _vm._v("基本情報入力")
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "mr-t-10 bg-white mr-l-30",
              staticStyle: {
                border: "1px solid #ccc",
                "margin-left": "30px",
                padding: "10px"
              }
            },
            [
              _c("div", { staticClass: "box-delivery-name m-b-md" }, [
                _c("div", { staticClass: "row" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-10 col-lg-7" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.shippingName,
                          expression: "shippingName",
                          modifiers: { trim: true }
                        }
                      ],
                      class: [
                        "form-control",
                        _vm.shippingName ? "" : "bg-no-input"
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.shippingName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.shippingName = $event.target.value.trim()
                        },
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "※セールモンスターのみが使用する項目です。セラー様が管理しやすい名称をご入力ください。"
                      )
                    ]),
                    _vm._v(" "),
                    _vm.validateErrors.shippingName.length
                      ? _c("div", { staticClass: "text-red" }, [
                          _c("b", [
                            _vm._v(_vm._s(_vm.validateErrors.shippingName[0]))
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._m(2)
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mr-t-20", staticStyle: { "min-width": "1500px" } },
        [
          _c("div", { staticClass: "flexbox gap-15" }, [
            _c("svg", { attrs: { width: "50", height: "50" } }, [
              _c("circle", {
                attrs: {
                  cx: "25",
                  cy: "25",
                  r: "20",
                  stroke: "#008cc6",
                  "stroke-width": "3",
                  fill: "#008cc6"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  attrs: {
                    x: "50%",
                    y: "50%",
                    "text-anchor": "middle",
                    "dominant-baseline": "central",
                    "font-size": "20",
                    fill: "#fff"
                  }
                },
                [_vm._v("2")]
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "font-bold text-size-16 text-primary" }, [
              _vm._v("商品情報入力")
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "mr-t-10 bg-white mr-l-30",
              staticStyle: {
                border: "1px solid #ccc",
                "margin-left": "30px",
                padding: "10px"
              },
              attrs: { id: "product-input" }
            },
            [
              _c("fixed-header", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShowFixedHeader,
                    expression: "isShowFixedHeader"
                  }
                ],
                attrs: { textBtnRegister: "出荷依頼" },
                on: {
                  handleClickAdd: function($event) {
                    _vm.openModalDeliveryProductAdd()
                  },
                  handleClickRegister: function($event) {
                    _vm.submitValidate()
                  }
                }
              }),
              _vm._v(" "),
              _c("p", {}, [
                _vm._v("出荷する商品を選択し、商品情報を入力してください。")
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary check-maintenance",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.openModalDeliveryProductAdd()
                    }
                  }
                },
                [_vm._v("商品選択")]
              ),
              _vm._v(" "),
              _vm.selectedProducts.length
                ? _c("div", { staticClass: "table-selected-products" }, [
                    _c("table", { staticClass: "full-width" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.selectedProducts, function(
                          selectedProduct,
                          index
                        ) {
                          return _c("tr", { key: index }, [
                            _c("td", { staticClass: "text-center" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "box-selected-product-image w-40"
                                },
                                [
                                  _c("img", {
                                    staticClass:
                                      "selected-product-image img-responsive",
                                    attrs: {
                                      src: selectedProduct.image,
                                      alt: ""
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class:
                                    "box-delivery-judgment-status " +
                                    _vm.getJudgmentStatusClass(
                                      selectedProduct.status_str
                                    )
                                },
                                [_vm._v(_vm._s(selectedProduct.status_str))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("div", { staticClass: "m-b-xs" }, [
                                _vm._v(_vm._s(selectedProduct.itemName))
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("b", [_vm._v("ASIN：")]),
                                _vm._v(_vm._s(selectedProduct.asin) + " / "),
                                _c("b", [_vm._v("SKU：")]),
                                _vm._v(_vm._s(selectedProduct.sku) + " ")
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("b", [_vm._v("商品ID：")]),
                                _vm._v(_vm._s(selectedProduct.itemId) + " / "),
                                _c("b", [_vm._v("商品ラベル：")]),
                                _vm._v(_vm._s(selectedProduct.goodsLabel))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.formatNumber(
                                      selectedProduct.amazonQuantity
                                    )
                                  ) +
                                  " 個\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { attrs: { colspan: "2" } }, [
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "text-right w-200 no-borders no-padding"
                                  },
                                  [
                                    _c("span", {}, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatNumber(
                                            selectedProduct.acrossQuantity
                                          )
                                        ) + " 個"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    selectedProduct.dueDateManageFlg
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "product-bubble-wrapper"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "text--underline",
                                                attrs: {
                                                  href: "javascript:void(0)"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.getStockByExpDate(
                                                      $event,
                                                      selectedProduct
                                                    )
                                                  },
                                                  mouseleave: function($event) {
                                                    _vm.closeBubble($event)
                                                  }
                                                }
                                              },
                                              [_vm._v("有効期限毎に表示")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: false,
                                                    expression: "false"
                                                  }
                                                ],
                                                staticClass:
                                                  "product-bubble bubble"
                                              },
                                              _vm._l(_vm.stockInfo, function(
                                                item,
                                                index
                                              ) {
                                                return _vm.stockInfo
                                                  ? _c("div", { key: index }, [
                                                      item.quantity > 0
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.expirationDateDisplay
                                                              ) +
                                                                " : " +
                                                                _vm._s(
                                                                  item.quantity
                                                                ) +
                                                                "個"
                                                            )
                                                          ])
                                                        : _vm._e()
                                                    ])
                                                  : _vm._e()
                                              }),
                                              0
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "no-borders" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: selectedProduct.quantity,
                                        expression: "selectedProduct.quantity"
                                      }
                                    ],
                                    staticClass:
                                      "form-control expected-delivery-number text-right mr-l-10",
                                    class:
                                      parseInt(selectedProduct.quantity) &&
                                      parseInt(selectedProduct.quantity) <=
                                        parseInt(selectedProduct.acrossQuantity)
                                        ? ""
                                        : "bg-no-input",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: selectedProduct.quantity
                                    },
                                    on: {
                                      input: [
                                        function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            selectedProduct,
                                            "quantity",
                                            $event.target.value
                                          )
                                        },
                                        function($event) {
                                          selectedProduct.quantity = _vm.handleInputQuantity(
                                            selectedProduct.quantity
                                          )
                                        }
                                      ],
                                      blur: _vm.updateStorageProducts
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.validateErrors.quantity[
                                selectedProduct.itemId
                              ] &&
                              _vm.validateErrors.quantity[
                                selectedProduct.itemId
                              ].length
                                ? _c(
                                    "div",
                                    { staticClass: "text-red text-right" },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.validateErrors.quantity[
                                              selectedProduct.itemId
                                            ][0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-center" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-delete-selected-product check-maintenance",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      _vm.deleteDeliverySelectedProduct(
                                        selectedProduct
                                      )
                                    }
                                  }
                                },
                                [_vm._v("削除")]
                              )
                            ])
                          ])
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-center m-b-md m-t-md" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary custom-btn check-maintenance",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.submitValidate($event)
                            }
                          }
                        },
                        [
                          _vm._v("\n            出荷依頼\n            "),
                          _c("i", {
                            staticClass: "fa fa-check fa-lg mr-l-5",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    ])
                  ])
                : _c("div", { staticClass: "empty-products text-center" }, [
                    _vm._m(4)
                  ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.openShippingProductAddModal
        ? _c("shipping-amazon-product-add", {
            ref: "shippingAmazonProductAddModal",
            attrs: {
              iconUrls: _vm.iconUrls,
              selectedProducts: _vm.storageSelectedProducts
            },
            on: {
              close: _vm.closeModalProductAdd,
              handleSelectedProduct: _vm.handleSelectedProduct,
              handleSelectedProducts: _vm.handleSelectedProducts
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showGetLatestProductModal
        ? _c("modal-alert-get-latest-product", {
            attrs: {
              message: _vm.getLatestProductNotiMessage,
              customBodyClass: "text-center"
            },
            on: {
              close: _vm.closeGetLatestProductModal,
              confirm: _vm.confirmGetLatestProductModal
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showGetLatestProductCompletedModal
        ? _c("modal-alert", {
            attrs: {
              message: _vm.getLatestProductCompletedMessage,
              customBodyClass: "text-center"
            },
            on: { close: _vm.closeGetLatestProductCompletedModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openAlertValidateFailsModal
        ? _c("modal-alert", {
            attrs: { message: _vm.alertValidateFailsMessage, customHide: true },
            on: { close: _vm.closeModalAlertValidateFails }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openShippingProductsAddConfirmModal
        ? _c("modal-confirm", {
            attrs: { message: _vm.shippingProductsAddConfirmMessage },
            on: {
              confirm: _vm.shippingProductsAdd,
              close: _vm.closeModalConfirmShippingProductsAdd
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openAlertProductsAddedModal
        ? _c("modal-alert", {
            attrs: {
              message: _vm.alertProductsAddedMessage,
              customHide: true,
              modalWidth: 550
            },
            on: { close: _vm.closeModalAlertProductsAdded }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "mr-t-15 text-warning bg-warning font-bold",
        staticStyle: { "margin-left": "30px", width: "850px" }
      },
      [
        _c("span", { staticStyle: { padding: "10px" } }, [
          _vm._v("2営業日以内を目途に出荷されます。")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-2 col-lg-1 w-150" }, [
      _c("div", { staticClass: "delivery-name" }, [
        _c("strong", [_vm._v("出荷名")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box-origin-info-default m-b-sm" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-2 col-lg-1 w-150" }, [
          _c("div", { staticClass: "m-b-sm" }, [
            _c("strong", [_vm._v("発送元情報")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-9 col-lg-10" }, [
          _vm._v("\n            ACROSS倉庫\n          ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-center w-150" }, [
          _vm._v("出荷する商品")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "min-width": "500px" } }),
        _vm._v(" "),
        _c("th", { staticClass: "text-right w-150" }, [_vm._v("Amazon在庫数")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right w-200" }, [_vm._v("ACROSS在庫数")]),
        _vm._v(" "),
        _c("th", { staticClass: "w-120" }, [_vm._v("出荷予定数")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center w-100" }, [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "m-b-xl text-center" }, [
      _c("strong", [_vm._v("商品選択より、出荷する商品を選択してください。")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71978f40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71978f40","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAcross/AmazonShipping.vue
// module id = null
// module chunks = 